export default "https://cdn-static.gokick.com/assets/7e8bc23aa9277111cd73fa77d581d1f801b67d5a/images/tangerine-flavor.d69a41b483f65480106dc4280eb6f29c.png";